module.exports = __webpack_public_path__ + "img/miss.6b4bce21.png";